import { AxiosService } from './axios.service'

/**
 * Defines the API methods for a client
 */
export class AddressService {
	static baseURL = 'endereco'

	/**
	 * Gets the user addresses
	 * @return {Promise<long>} The user ID
	 */
	static getAddresses(userId) {
		const parameters = userId === undefined ? '' : `/${userId}/`
		return AxiosService.get(`${AddressService.baseURL}${parameters}`).then(
			({ data }) => data
		)
	}

	/**
	 * Inactivates an address
	 * @return {Promise<long>} The balance points
	 */
	static inactivateAddress(userId, addressId) {
		return AxiosService.post(
			`${AddressService.baseURL}/inativar/${userId || 0}/${addressId}`
		).then(({ data }) => data)
	}

	/**
	 * Adds or updates an address
	 * @return {Promise<long>}
	 */
	static addOrUpdate(userId, address) {
		return AxiosService.post(
			`${AddressService.baseURL}/adicionar-ou-atualizar/${userId || 0}`,
			address
		).then(({ data }) => data)
	}
}
